import { useCallback, useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

/** Jak dlouho jde smazani vratit. */
const TOAST_MS = 6000

interface Toast {
  key: number
  text: string
  undo(): void
}

/**
 * „Smazáno · Vrátit" (navrh v3): nic nezmizi potichu. Lista je nad patickou,
 * vraceni obstara volajici (treba znovu pridat polozku).
 */
export function useUndoToast() {
  const [toast, setToast] = useState<Toast | null>(null)

  useEffect(() => {
    if (!toast) return
    const timer = setTimeout(() => setToast(null), TOAST_MS)
    return () => clearTimeout(timer)
  }, [toast])

  const show = useCallback((text: string, undo: () => void) => setToast({ key: Date.now(), text, undo }), [])

  const node =
    toast &&
    createPortal(
      <div key={toast.key} className="undo-toast" role="status">
        <span className="undo-toast-text">{toast.text}</span>
        <button
          type="button"
          className="undo-toast-btn"
          onClick={() => {
            toast.undo()
            setToast(null)
          }}
        >
          Vrátit
        </button>
      </div>,
      document.body,
    )

  return { showUndo: show, undoToast: node }
}
